import angular from 'angular';
import loansSignUpFormSimulationComponent from './loansSignUpFormSimulation.component';
import loansSignUpFormSimulationHousingChangeWarning from './loansSignUpFormSimulationHousingChangeWarning/loansSignUpFormSimulationHousingChangeWarning';

let loansSignUpFormSimulationModule = angular.module('loansSignUpFormSimulation', [
  loansSignUpFormSimulationHousingChangeWarning
])

.component('loansSignUpFormSimulation', loansSignUpFormSimulationComponent)

.name;

export default loansSignUpFormSimulationModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpFormSimulation/loansSignUpFormSimulation.js